import createIcon from "../create-icon";

export const LayoutGridIcon = createIcon("LayoutGrid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", key: "i95qnx" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", key: "14o0il" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", key: "1bd5jp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", key: "8pmw4r" }],
]);
